import { useTranslation } from "react-i18next";
import { usePartViewMilestone } from "pages/partview/utils/milestone.utils";
import { Text } from "components/atoms/Text.atom";
import { DateTime } from "components/atoms/DateTime.atom";
import { Location } from "pages/partview/utils/milestone.utils";

interface PackageMilestoneCellProps {
  value: {
    readonly code: string;
    readonly location: Location;
    readonly dateTime: string;
    readonly status: string;
  };
}

export const PackageMilestoneCell = ({ value }: PackageMilestoneCellProps) => {
  const { t } = useTranslation("partview-search");
  const { code, location, dateTime, status } = value;
  const milestone = usePartViewMilestone(code);

  return (
    <div css={{ display: "flex", flexDirection: "column" }}>
      {status ? (
        <div className="d-flex flex-wrap">
          <Text bold>
            {t("partview-search:Status")}: <Text>{status}</Text>
          </Text>
        </div>
      ) : null}
      {milestone?.description ? (
        <Text bold>{milestone.description}</Text>
      ) : null}
      {location?.name ? <Text block>{location.name}</Text> : null}
      {dateTime ? (
        <div className="d-flex flex-wrap">
          <Text bold>{t("partview-search:Event Time")}: </Text>
          <DateTime
            dateTime={dateTime}
            localize
            plain
            className="ms-1"
            fallback={<Text className="ms-1">{t("partview-search:N/A")}</Text>}
          />
        </div>
      ) : null}
    </div>
  );
};
